import React, { Component } from "react";
var CurrencyFormat = require("react-currency-format");
export class FormatCurrency extends Component {
  render() {
    return (
      <CurrencyFormat
        value={this.props.value}
        style={{fontFamily:"Rubik-Regular"}}
        displayType={"text"}
        thousandSeparator={true}
        prefix={!!this.props.noprefix?"":"₹"}
        thousandSpacing="2s"
        decimalScale={0}
      />
    );
  }
}
